import MAIN_LOGO from "@/assets/branding/logo.svg";
import classNames from "classnames";
import { FC } from "react";
// import MAIN_LOGO_ICON from "@/assets/branding/icon.svg";
import { Link } from "react-router-dom";

interface BrandingType {
  className?: string;
}

const Branding: FC<BrandingType> = ({ className }) => {
  return (
    <div
      className={classNames(
        "branding flex items-center justify-center min-w-8 sm:min-w-32 max-w-32 sm:w-32 py-6 px-1 sm:mx-1",
        className
      )}
    >
      <Link to="/" className="flex items-center justify-center">
        <img src={MAIN_LOGO} alt="Aalyana" className="w-full object-contain" />
        {/* <img src={MAIN_LOGO_ICON} alt="Aalyana" className="w-full block sm:hidden object-contain" /> */}
      </Link>
    </div>
  );
};

export default Branding;
